import React, { FC, useState } from 'react';
import { Image } from 'react-native';
import ButtonGroup from '../ButtonGroup';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import HeaderOne from '../HeaderOne';
import HeaderTwo from '../HeaderTwo';
import LinearGradientButton from '../LinearGradientButton';
import View from '../View';
import styles from './styles';

export type UserOnboardingProps = {
  setShowOnboardingFlow: (e: boolean) => void;
};

export const UserOnboarding: FC<UserOnboardingProps> = (props) => {
  const { setShowOnboardingFlow } = props;
  const [currentStep, setCurrentStep] = useState(0);

  const determineCurrentStep = (direction) => {
    if (direction === 'next' && currentStep !== 2) {
      setCurrentStep(currentStep + 1);
    }
    if (direction === 'back' && currentStep !== 0) {
      setCurrentStep(currentStep - 1);
    }
    if (direction === 'next' && currentStep === 2) {
      setShowOnboardingFlow(false);
    }
  };
  const stepData = {
    0: {
      title: 'Step 1',
      description: 'Connect ToneBirds to your Spotify Premium account',
      imagePath: require('./assets/connect.png'),
    },
    1: {
      title: 'Step 2',
      description: 'Listen to songs and tell the artist how you feel',
      imagePath: require('./assets/fan_feedback.png'),
    },
    2: {
      title: 'Step 3',
      description:
        'The Artist receives your feedback and feels connected to you',
      imagePath: require('./assets/artist_review.png'),
    },
  };
  return (
    <View style={styles.container}>
      <HeaderOne title="Welcome!" />
      <HeaderTwo title="How to use ToneBirds" />
      <HeaderTwo title={stepData[currentStep].title} style={styles.stepStyle} />
      <Image source={stepData[currentStep].imagePath} style={styles.image} />
      <GalanoGrotesqueText style={styles.text}>
        {stepData[currentStep].description}
      </GalanoGrotesqueText>
      <ButtonGroup direction="row" style={styles.buttonGroup}>
        <LinearGradientButton
          disabled={currentStep < 1}
          title="Back"
          onPress={() => determineCurrentStep('back')}
        />

        <LinearGradientButton
          title="Next"
          onPress={() => determineCurrentStep('next')}
        />
      </ButtonGroup>
    </View>
  );
};

export default UserOnboarding;
